<br>

<div id="page_loader" class="page-loader no-display">
	<div class="spinner"></div>
</div>

<div class="return-form"
		 id="form">
	<div class="row">
		@if (!isMobile) {
			<div class="col-lg-3 col-md-12 col-sm-12 order-lg-1 order-md-2">
				<div class="row side-menu">
					<div class="sidebar-content">
						<span class="sidebar-title" id="my_account">{{ 'orderViewPage.my_account' | translate }}</span>
						<p id="sidebar-text-name" class="sidebar-text">{{ client.firstname }} {{ client.lastname }}</p>
					</div>
					<div class="sidebar-content">
						<span class="sidebar-title"></span>
						<p id="sidebar-text-address"
							 class="sidebar-text">{{ client.address?.street }} {{ client.address?.number }}</p>
						<p id="sidebar-text-zip" class="sidebar-text">{{ client.address?.postcode }}</p>
						<p id="sidebar-text-city" class="sidebar-text">{{ client.address?.city }}</p>
					</div>
				</div>
				<div class="row side-menu-list">
					<p class="return-requests-p">{{ 'orderViewPage.return_card_title' | translate }}</p>
					@for (returnRequest of returns; track returnRequest) {
						<div class="card m-b-5">
							<div class="card-body">
								<h6>{{ 'orderViewPage.return_number' | translate }}: {{ returnRequest.return_no }}</h6>
								<h6 class="card-title">{{ 'orderViewPage.return_card_date' | translate }}
									: {{ returnRequest.return_date }}
								</h6>
								<p></p>
								<button (click)="your_return_view(returnRequest.return_no);"
												class="btn">{{ 'orderViewPage.return_card_button' | translate }}
								</button>
							</div>
						</div>
					}
				</div>
			</div>
		}

		<div class="col-lg-9 col-md-12 col-sm-12 order-lg-2 order-content order-md-1">
			<h2 id="your_order_text">{{ 'orderViewPage.your_order' | translate }}</h2>
			<!--      Mobile view of list      -->
			@if (isMobile) {
				<div class="mobile-view">
					<div class="order-summary">
						<div>
							<div class="title">
								{{ 'orderViewPage.order_num' | translate }}
							</div>
							<div class="info">
								{{ order_header?.order_number }}
							</div>
						</div>
						<div>
							<div class="title">
								{{ 'orderViewPage.status' | translate }}
							</div>
							<div class="info">
								{{ order_header?.mappedOrderStatus }}
							</div>
						</div>
						<div>
							<div class="title">
								{{ 'orderViewPage.order_date' | translate }}
							</div>
							<div class="info">
								{{ order_header?.order_date | date : 'dd.MM.yyyy' }}
							</div>
						</div>
						<div>
							<div class="title">
								{{ 'orderViewPage.total_value' | translate }}
							</div>
							<div class="info">
								{{ order_header?.total_paid | number : '1.2-2' }} {{ order_header?.currency }}
							</div>
						</div>
					</div>

					<div class="side-menu-list">
						<p class="return-requests-p">{{ 'orderViewPage.return_card_title' | translate }}</p>
						@for (returnRequest of returns; track returnRequest) {
							<div class="card m-b-5 mobile-return-card">
								<div class="card-body mobile-return-card-body">
									<div class="mobile-return-card-meta">
										<div class="mobile-return-card-row">
											<div class="mobile-return-card-pair">
												<span class="mobile-return-card-label">{{ 'orderViewPage.return_number' | translate }}:</span>
												<span class="mobile-return-card-value">{{ returnRequest.return_no }}</span>
											</div>
											<div class="mobile-return-card-pair mobile-return-card-pair-right">
												<span class="mobile-return-card-label">{{ 'orderViewPage.return_card_date' | translate }}
													:</span>
												<span class="mobile-return-card-value">{{ returnRequest.return_date }}</span>
											</div>
										</div>
									</div>
									<button (click)="your_return_view(returnRequest.return_no);"
													class="btn mobile-return-card-button">
										{{ 'orderViewPage.return_card_button' | translate }}
									</button>
								</div>
							</div>
						}
					</div>

					<div class="order-list">
						<div class="title">
							{{ 'orderViewPage.items' | translate | uppercase }}
						</div>
						@for (orderItem of items; track orderItem; let i = $index) {
							<div class="mobile-card">
								@if (orderItem.status === productStatusEnum.FULFILLED) {
									<input
										class="order-checkbox"
										id="{{orderItem.article_code}}"
										type="checkbox"
										[ngModel]="orderItem.checked"
										(click)="checked_row(orderItem, i, $event)"
										value="{{orderItem.checked}}"
										name="{{orderItem.article_code}}">
								}
								<div class="mobile-details">
									<div class="mobile-details">
										<div class="mobile-body">
											<img class="sku-image"
													 (click)="onSelectReasonModal(orderItem, i)"
													 src="{{orderItem.img}}"
													 height="120"
													 loading="lazy"
													 decoding="async">
											<div class="card-info"
													 (click)="onSelectReasonModal(orderItem, i)">
												<div>
													{{ orderItem.article_code }}
												</div>
												<div class="item-info">
													<div>
														<div>
															{{ orderItem.article_color }}
														</div>
														@if (orderItem.status === productStatusEnum.NOT_FULFILLED || orderItem.status === productStatusEnum.CANCELLED) {
															<div class="error">
																{{ 'orderViewPage.article_not_available' | translate }}
															</div>
														}
														<div>{{ 'orderViewPage.size' | translate }} {{ orderItem.article_size }}</div>
													</div>
													<div>
														<strong>{{ 'orderViewPage.price_per_item' | translate }}</strong>
														{{ orderItem.selling_price | number : '1.2-2' }} {{ order_header?.currency }}
													</div>
													<div>
														<strong>Total:</strong>{{ orderItem.pricePerBundle | number : '1.2-2' }} {{ order_header?.currency }}
													</div>
												</div>
											</div>
										</div>
										@if (orderItem.status === productStatusEnum.FULFILLED) {
											<button class="dropdown-btn"
															(click)="onSelectReasonModal(orderItem, i)">
												@if (orderItem.return_reason && orderItem.return_reason !== '-') {
													<span>{{ 'orderViewPage.' + (orderItem.return_reason || '-') | translate }}</span>
												} @else {
													<span>{{ 'orderViewPage.please_select_reason' | translate }}</span>
													<span> > </span>
												}
											</button>
										}
										@if (orderItem.return_reason && orderItem.status === productStatusEnum.FULFILLED) {
											<button class="dropdown-btn"
															(click)="onSelectQuantity(orderItem, i)">
												{{ orderItem.selectedQuantity }}
											</button>
											<div>
												{{ 'orderViewPage.return_value'  | translate }} {{ (orderItem.selectedQuantity * orderItem.selling_price) | number : '1.2-2' }} {{ order_header?.currency }}
											</div>
										}
									</div>
								</div>
							</div>
						}
					</div>
					<div class="button-mobile">
						<button type="button"
										(click)="cancel()"
										class="btn">{{ 'orderViewPage.cancel_return' | translate }}
						</button>
						<div class="download-btn">
							<button type="button"
											[disabled]="invalidForm || disableDownloadButton"
											[class.btn-inactive]="invalidForm || disableDownloadButton"
											(click)="addReturn()"
											class="btn">{{ 'orderViewPage.button_next' | translate }}
							</button>
							<div class="sku-color">{{ 'orderViewPage.info' | translate }}</div>
						</div>

					</div>
				</div>
			}
			<!--      Desktop view of list      -->
			@if (!isMobile) {
				<div class="table-responsive">
					<form id="return_select">
						<table class="table table-sm order-table">
							<thead>
							<tr>
								<th id="th1_text" scope="col" colspan="3">{{ 'orderViewPage.order_num' | translate }}</th>
								<th id="th2_text" scope="col">{{ 'orderViewPage.status' | translate }}</th>
								<th id="th3_text" scope="col" class="text-center">{{ 'orderViewPage.items' | translate }}</th>
								<th id="th4_text" scope="col"></th>
								<th id="th5_text" scope="col">{{ 'orderViewPage.order_date' | translate }}</th>
								<th id="th6_text" scope="col" colspan="2">{{ 'orderViewPage.total_value' | translate }}</th>
							</tr>
							<tr>
								<th id="order_number" scope="col" colspan="3">{{ order_header?.order_number }}</th>
								<th id="status" scope="col">{{ order_header?.mappedOrderStatus }}</th>
								<th id="items" scope="col" class="text-center">{{ totalQuantity }}</th>
								<th scope="col"></th>
								<th id="order_date" scope="col" class="w-100">{{ order_header?.order_date | date : 'dd.MM.yyyy' }}</th>
								<th id="total_value" scope="col"
										colspan="2">{{ order_header?.total_paid | number : '1.2-2' }} {{ order_header?.currency }}
								</th>
							</tr>
							</thead>
							<tbody id="table_body">
								@for (item of items; track item; let i = $index) {
									<tr
										[class.checked]="item.checked"
										id="sku-{{item.article_code}}">
										<td [attr.colspan]="4">
											<label class="checkbox">
												@if (item.status === productStatusEnum.FULFILLED) {
													<input
														class="order-checkbox"
														id="{{item.article_code}}"
														type="checkbox"
														value="{{item.checked}}"
														(click)="checked_row(item, i)"
														name="sku">
												}
												<span></span>
												<span class="order-sku">
                    {{ item.article_code }}
													@if (item.status === productStatusEnum.NOT_FULFILLED || item.status === productStatusEnum.CANCELLED) {
														<div class="error">
                      {{ 'orderViewPage.article_not_available' | translate }}
                    </div>
													}
                  </span>
											</label>
										</td>
										<td>
											<div class="item">
												<img class="sku-image" src="{{item.img}}" height="100" loading="lazy" decoding="async">
												<div class="sku-detail" style="margin-left: 10px">
													<span class="sku-group">{{ item.article_group }}</span>
													<span class="sku-color">{{ item.article_color }}</span>
													<span class="sku-size">{{ 'orderViewPage.size' | translate }} {{ item.article_size }}</span>
													<span>{{ 'orderViewPage.numberOfItems' | translate }} {{ item.quantity }}</span>
													<span>{{ 'orderViewPage.price_per_item' | translate }} {{ item.selling_price | number : '1.2-2' }} {{ order_header?.currency }}</span>
												</div>
											</div>
										</td>
										<td [attr.colspan]="3">
											@if (item.checked) {
												<div class="dropdown">
													<label for="reasons"
																 [class.return-reason-error]="!item.return_reason || item.return_reason === '-'">{{ 'orderViewPage.return_reason' | translate }}</label>
													<select name="reasons"
																	[class.border-error]="!item.return_reason || item.return_reason === '-'"
																	(change)="onSelect($event, i)">
														@for (reason of returnReasons; track reason) {
															<option [value]="reason">
																{{ 'orderViewPage.' + reason | translate }}
															</option>
														}
													</select>
												</div>
												<div class="dropdown">
													<label for="numberOfItems">{{ 'orderViewPage.number_of_returned' | translate }}</label>
													<select name="numberOfItems"
																	(change)="onQuantityChange($event, i)">
														@for (quantityEntity of item.quantityList; track quantityEntity) {
															<option [value]="quantityEntity">
																{{ quantityEntity }}
															</option>
														}
													</select>
													<span>{{ 'orderViewPage.return_value'  | translate }} {{ (item.selectedQuantity * item.selling_price) | number : '1.2-2' }} {{ order_header?.currency }}</span>
												</div>
											}
										</td>
										<td colspan="2">{{ item.pricePerBundle | number : '1.2-2' }} {{ order_header?.currency }}</td>

								}
							<tr class="no-opacity">
								<td class="no-border-bottom"
										colspan="4">
									<button type="button"
													id="cancel-return"
													style="min-width:220px !important;"
													(click)="cancel()"
													class="btn">{{ 'orderViewPage.cancel_return' | translate }}
									</button>
								</td>
								<td class="no-border-bottom"
										colspan="5">
									<button type="button"
													style="width:220px !important;"
													[disabled]="invalidForm || disableDownloadButton"
													[class.btn-inactive]="invalidForm || disableDownloadButton"
													id="next-btn"
													(click)="addReturn()"
													class="btn">{{ 'orderViewPage.button_next' | translate }}
									</button>
									@if (invalidForm || disableDownloadButton) {
										<div class="sku-color error-info-message">
											{{ 'orderViewPage.return_reason_error_text' | translate }}
										</div>
									}
								</td>
							</tr>
							<tr>
								<td class="no-border-top no-border-bottom"
										colspan="9">
									<span class="sku-color">{{ 'orderViewPage.info' | translate }}</span>
								</td>
							</tr>
							</tbody>
						</table>
					</form>
				</div>
			}
		</div>
	</div>
</div>


<!-- Modal -->
<div class="modal fade" id="quantity_error" tabindex="-1" role="dialog" aria-labelledby="quantity_errorLabel"
		 aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="quantity_errorLabel">{{ 'orderViewPage.modal_quantity_error' | translate }}</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<strong
					id="return_reason_error_text">{{ 'orderViewPage.modal_quantity_error_text' | translate }}</strong><br><br>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn fs-14 m-r-a m-l-0" data-bs-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="no_order_item" tabindex="-1" role="dialog" aria-labelledby="no_order_itemLabel"
		 aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="return_reason_errorLabel">Order item error!</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<strong id="no_order_item_text">You can't return articles from this order!</strong><br><br>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn fs-14 m-r-a m-l-0" data-bs-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>

<div id="process_loading" class="loading2 no-display">
	<div class="loading">
		<div style="text-align: center">
			<h3 class="threeD-text">
				<div>
					{{ 'orderViewPage.process_request_1' | translate }}
				</div>
				<div class="text-break">
					{{ 'orderViewPage.process_request_2' | translate }}
				</div>
			</h3>
			<div style="text-align: center">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	</div>
</div>
